angular.module("app").component("studentSingleSignOnComponent", {
  templateUrl: "app/components/student-single-sign-on/student-single-sign-on.tmpl.html",
  controller: function (authService, $state, $stateParams, localStorageService) {
    const self = this;
    self.failed = false;
    self.failMsg = "";

    const messages = {
      "unknown-school": "Your organization's SSO isn't set up with Huedata yet.",
      invalid: "Your organization's sign-in response couldn't be verified.",
      "no-email": "Your organization didn't share an email address with us.",
      account: "We couldn't open an account for you.",
      e: "Your organization didn't approve this sign-in.",
    };

    const fail = (code) => {
      self.failed = true;
      self.failMsg = messages[code] || messages.e;
    };

    self.init = function () {
      // Old SSO link (#!/single-sign-on/saml/login) now lives on the school page
      if ($stateParams.success === "saml") {
        $state.go("school-enterprise-login");
        return;
      }
      if ($stateParams.success !== "t") {
        fail($stateParams.token);
        return;
      }
      const remember = !!localStorageService.get("ssoRemember");
      localStorageService.remove("ssoRemember");
      authService
        .schoolSSOLoginUser($stateParams.token, remember)
        .then((res) => {
          if (res && res.success === true) {
            $state.go("landing-page");
          } else {
            fail("account");
          }
        })
        .catch(() => fail("account"));
    };
  },
});
